export default class PeriodenCalcDto {

  constructor(json) {
    if (json) {
      this.von = json.von;
      this.bis = json.bis;
      this.dauer = json.dauer;
      this.anzahl = json.anzahl;
      this.perioden = json.perioden;
      this.truncated = json.truncated;
    } else {
      this.json = {}
      this.perioden = []
    }
  }
}
